import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { messages } from './messages';
import { Language } from './language';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private readonly renderer: Renderer2;
  language: Language = Language.Czech;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  initLanguage() {
    let lang = window.navigator.language || 'cs';
    if (lang.length > 2)
      lang = lang.substring(0, 2);

    if (lang == 'sk')
      this.language = Language.Czech;
    else if (lang == 'pl')
      this.language = Language.Polish;
    else if (lang == 'en')
      this.language = Language.English;

    this.renderer.setAttribute(document.documentElement, 'lang', this.language);
  }

  /**
   * Get translation from dictionary for given argument
   * @param toTranslate text to translate
   */
  translate(toTranslate: string): string {
    if (!messages[toTranslate])
      return `Unknown message key: ${toTranslate}`;

    switch (this.language) {
      case Language.English:
        return messages[toTranslate].en;
      case Language.Polish:
        return messages[toTranslate].pl;
      default:
        return messages[toTranslate].cz;
    }
  }

  setLocale(lang: Language) {
    this.language = lang;
    this.renderer.setAttribute(document.documentElement, 'lang', this.language);
  }
}
